import React from "react";
import {
    Button,
    Disclosure,
    DisclosureGroup,
    DisclosurePanel,
    Heading,
} from "react-aria-components";

import {
    AccordionBlock as BlockValue,
    AccordionEntry as EntryValue,
} from "@reactivated";

import { RichText } from "../RichText";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

function Entry({ value, id }: { value: EntryValue; id: string }) {
    return (
        <Disclosure id={id} className={styles.entry}>
            <Heading>
                <Button className={styles.button} slot="trigger">
                    <span className={styles.header}>{value.header}</span>
                    <Svg name="plus" />
                </Button>
            </Heading>
            {value.panel_content && (
                <DisclosurePanel className={styles.panel}>
                    <RichText value={value.panel_content} />
                </DisclosurePanel>
            )}
        </Disclosure>
    );
}

export function AccordionBlock({
    value,
    id,
}: {
    value: BlockValue;
    id?: string;
}) {
    return (
        <div className={styles.root}>
            <DisclosureGroup>
                {value.entries?.map((entry, index) => (
                    <Entry
                        key={`accordion-${id}-${index}`}
                        id={`accordion-${id}-${index}`}
                        value={entry}
                    />
                ))}
            </DisclosureGroup>
        </div>
    );
}
